import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useAssets from "../../../../hooks/useAssets";
import useScheduling from "../../../../hooks/useScheduling";
import { Loading } from "../../../../utils/loading";
import { Asset } from "../../../../models/asset";
import { getAssetRioPlan } from "../../../../services/assetService";
import VehicleIcon from "../../../../components/VehicleIcon";

const Details = (props: any) => {
    const { id } = useParams();

    const { loading, scheduling } = useScheduling(id);
    const { allAssets } = useAssets();
    const [asset, setAsset] = useState<Asset | undefined>(undefined);

    useEffect(() => {
        if(scheduling) {
            const asset = allAssets.find(asset => asset.id === scheduling.asset?.id);
            if(asset) setAsset(asset);
        }
    }, [scheduling]);     

    const { plans } = getAssetRioPlan(scheduling?.asset?.id ?? '');

    return (
        <>
            {loading ?
                <Loading label="Carregando agendamento..." /> :
                <div className="scheduling-page resume-section p-10">
                    <h2 className="text-size-h2 text-center text-color-black font-semibold padding-top-20 padding-bottom-20">
                        Resumo do agendamento
                    </h2>
                    <div className="resume-container">
                        <h5 className="text-size-20 text-color-black font-bold margin-bottom-20 text-color-gray">
                            {scheduling?.scheduleNumber}
                        </h5>

                        <div className="row schedule-data">
                            <div className="col-4">
                                <label className="block text-sm text-size-20 text-color-black font-bold margin-bottom-10">
                                    Motorista
                                </label>
                                <div className="mt-1 p-2 border schedule-data__info">
                                    <div className="truncate">
                                        {scheduling?.driver?.name}
                                    </div>
                                </div>
                            </div>
                            <div className="col-2">
                                <label className="block text-sm text-size-20 text-color-black font-bold margin-bottom-10">
                                    CNH
                                </label>
                                <div className="mt-1 p-2 border schedule-data__info">
                                    <div className="truncate">
                                        {scheduling?.driver?.license}
                                    </div>
                                </div>
                            </div>
                            <div className="col-3">
                                <label className="block text-sm text-size-20 text-color-black font-bold margin-bottom-10">
                                    Telefone
                                </label>
                                <div className="mt-1 p-2 border schedule-data__info">
                                    <div className="truncate">
                                        {scheduling?.driver?.phone}
                                    </div>
                                </div>
                            </div>
                            <div className="col-3">
                                <label className="block text-sm text-size-20 text-color-black font-bold margin-bottom-10">
                                    E-mail
                                </label>
                                <div className="mt-1 p-2 border schedule-data__info">
                                    <div className="truncate">
                                        {scheduling?.driver?.email}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="p-4 bg-lighter margin-top-20 vehicle-detais">
                            <div className="flex items-start gap-4">
                                <VehicleIcon 
                                    chassis={asset?.chassis ?? scheduling?.asset?.chassis} 
                                    size={80}
                                />

                                <div className="flex-1 padding-left-10">
                                    <p className="text-color-black text-size-16 font-medium m-0">
                                        {asset?.name ??scheduling?.asset?.name} | Placa:{" "}
                                        {asset?.licensePlate ?? scheduling?.asset?.licensePlate}
                                    </p>
                                    <p className="text-color-status-resting text-size-14 m-0">
                                        Chassi - {asset?.chassis ?? scheduling?.asset?.chassis}
                                        <br />
                                        Odômetro: {scheduling?.asset?.odometer} km | Horímetro:{" "}
                                        {scheduling?.asset?.hourmeter}
                                    </p>
                                </div>

                                {(scheduling?.asset?.plans?.length ?? 0) > 0 && (
                                    <div className="flex gap-6 margin-bottom-20">
                                        <span className="px-2 py-1 green-tag">RIO</span>
                                        <span className="px-2 py-1 green-tag">Em Garantia</span>
                                        {scheduling?.asset?.volksTotalPlan && (
                                            <span className="px-2 py-1 bg-white dark:bg-neutral-800 white-tag">
                                                Volkstotal {scheduling?.asset?.volksTotalPlan}
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="padding-top-10">
                                <div className="car-workshop">
                                    <ul className="flex flex-column gap-5 m-0">
                                        <li className="flex justify-between">
                                            <div className="text-color-black">Campanhas de campo</div>
                                            <div className="text-color-black font-bold">{scheduling?.asset?.id ? plans : 'Grátis'}</div>
                                        </li>

                                        <li className="flex justify-between">
                                            <div className="text-color-black">
                                                {scheduling?.checkup?.description}
                                            </div>
                                            <div className="text-color-black font-bold">{scheduling?.asset?.id ? plans : 'Grátis'}</div>
                                        </li>

                                        <li className="flex justify-between">
                                            <div className="text-color-black">Total em serviços</div>
                                            <div className="text-color-black">
                                                {scheduling?.totalPrice ?? "R$ 0,00"}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div className="revision-itens">
                            <h5 className="text-size-20 text-color-black font-bold margin-bottom-10">
                                Itens cobertos na revisão
                            </h5>
                            <div className="p-4 bg-white dark:bg-neutral-800 border dark:border-neutral-700">
                                <ul className="space-y-5 text-size-14 text-color-black m-0 padding-left-10">
                                    {(scheduling?.checkup?.parts ?? []).length === 0 && <p>-</p>}
                                    {(scheduling?.checkup?.parts ?? []).map((part, index) => (
                                        <div key={index} className="padding-bottom-10 flex justify-between">
                                            <p className="m-0">
                                                {part.description}
                                                {part.qtd ? ` (${part.qtd})` : ""}
                                            </p>
                                            {!part.isCovered && part.notCoveredReason && (
                                                <p className="m-0 text-color-status-resting">{part.notCoveredReason}</p>
                                            )}
                                        </div>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <div className="revision-itens">
                            <h5 className="text-size-20 text-bold margin-bottom-0">
                                Descrição dos Serviços Contratados
                            </h5>
                            <div className="text-size-14 margin-bottom-10">
                                Espaço para descrever informações importantes sobre "Serviços
                                Contratados", adicionados no agendamento.
                            </div>
                            <div className="p-4 bg-white dark:bg-neutral-800 border dark:border-neutral-700">
                                <ul className="space-y-5 text-size-14 text-color-black m-0 padding-left-10">
                                    {(scheduling?.otherServices ?? []).map((name, index) => (
                                        <div key={index}>
                                            <p>{name}</p>
                                        </div>
                                    ))}
                                    {(scheduling?.otherServices ?? []).length === 0 && <p>-</p>}
                                </ul>
                            </div>
                        </div>

                        <div className="revision-itens observation">
                            <h5 className="text-size-20 text-color-black font-bold margin-bottom-10">
                                Observações
                            </h5>
                            <div className="p-4 bg-white dark:bg-neutral-800 border dark:border-neutral-700">
                                <ul className="space-y-5 text-size-14 text-color-black m-0 padding-left-10">
                                    <li className="flex justify-between">
                                        <span>{scheduling?.observation || '-'}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="revision-itens flex justify-between gap-6">
                            <div className="w-1/3">
                                <h5 className="text-size-20 text-color-black font-bold margin-bottom-10">
                                    Concessionária
                                </h5>
                                <div className="p-4 bg-white dark:bg-neutral-800 border dark:border-neutral-700 card">
                                    <p className="m-0 text-size-h5">{scheduling?.dealership?.name}</p>
                                    <p className="m-0">{scheduling?.dealership?.address}</p>
                                </div>
                            </div>

                            <div className="w-1/3">
                                <h5 className="text-size-20 text-color-black font-bold margin-bottom-10">
                                    Data e horário:
                                </h5>
                                <div className="p-4 bg-white dark:bg-neutral-800 border dark:border-neutral-700 card">
                                    <p className="m-0 text-size-h5">
                                        {scheduling?.date.toLocaleDateString("pt-BR", {
                                            year: "numeric",
                                            month: "long",
                                            day: "2-digit",
                                        })}
                                    </p>
                                    <p className="m-0">
                                        {scheduling?.date.toLocaleTimeString("pt-BR", {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </p>
                                </div>
                            </div>

                            <div className="w-1/3">
                                <h5 className="text-size-20 text-color-black font-bold margin-bottom-10">
                                    Consultor:
                                </h5>
                                <div className="p-4 bg-white dark:bg-neutral-800 border dark:border-neutral-700 card">
                                    <p className="m-0 text-size-h5">{scheduling?.consultant}</p>
                                </div>
                            </div>
                        </div>

                        <div className="warning-row">
                            <h5 className="text-color-status-resting">Atenção!</h5>
                            <p className="text-color-warning text-size-18 font-semibold">
                                Os itens de cobertura do seu plano de contrato de manutenção estão
                                sujeitas a análise técnica de garantia, podendo a garantia ser
                                indeferida por violação e ou mau uso.
                            </p>
                        </div>
                        <div className="flex justify-between navigation-buttons step-4">
                            <button className="back-btn" onClick={() => window.history.back()}>
                                Voltar
                            </button>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default Details;